
import { AppToolbar, SideDrawer, Snackbar } from "@nokia-csf-uxr/ccfk";
import {
  AppBody,
  AppContent,
  AppContentWrapper,
  AppHeader,
} from "@nokia-csf-uxr/ccfk/App";
import {
  AppToolbarContent,
  AppToolbarTitle,
  AppToolbarTitleContainer,
} from "@nokia-csf-uxr/ccfk/AppToolbar";

import { SnackbarContent } from "@nokia-csf-uxr/ccfk/Snackbar";
import { showModal, showPopup } from "Store/auth";
import { RootState } from "Store/mainStore";
import { setTheme } from "Store/theme";
import React, { useState, createRef, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, NavLink, matchPath } from "react-router-dom";
import DialogModal from "./Elements/DialogModal";
import { deserializeFunction } from "Utils";
import SideDrawerList from "@nokia-csf-uxr/ccfk/SideDrawer/SideDrawerList";
import SideDrawerItem from "@nokia-csf-uxr/ccfk/SideDrawer/SideDrawerItem";

import SubscriptionFilter from "Pages/subscription/SubscriptionFilter";
import { useNavigate } from "react-router-dom";
import BreadCrum from "Pages/marketplace/common/BreadCrum";
import quotationIcon from "../Assets/Icons/quotations_icon.svg";
import FilterButtons from "Pages/marketplace/common/FilterButtons";
import {
  getIconForNavItem,
  getLabelForNavItem,
} from "../Constants/SideNavConstants";
import CommonFilter from "Pages/marketplace/common/CommonFilter";
import { NavBar } from "./NavBar";
import LoadNavLinks, { EXCLUDED_ITEMS } from "./LoadNavLinks";
import AccountBody from "Pages/subscription/Account/AccountBody";
import AccountInfo from "Pages/marketplace/Components/AccountInfo";
import Footer from "Pages/Footer";
import CartMessageSnackBar from "Pages/marketplace/common/SnackBar";
import Button, {
  ButtonText,
  ButtonIcon,
} from '@nokia-csf-uxr/ccfk/Button';
import AddIcon from '@nokia-csf-uxr/ccfk-assets/latest/AddIcon';
import { setProp } from "Store/Actions";
// SideDrawerButton removed to keep side navigation always expanded
import { KEY_CODES } from "@nokia-csf-uxr/ccfk/common";
import SelectBox from "Pages/subscription/Custom/SelectBox";
import { setDashboard } from "Store/contentState/merchantSlice";
import capturePencilIcon from "../Assets/Icons/capture-pencil-icon.svg"
import { formatDate } from "../Pages/marketplace/Utils/commons";
import HelpCircleIcon from '@nokia-csf-uxr/ccfk-assets/latest/InfoCircleFillSmallIcon';
import Tooltip from '@nokia-csf-uxr/ccfk/Tooltip';
import Typography from '@nokia-csf-uxr/ccfk/Typography';
import ChevronDownSmallIcon from '@nokia-csf-uxr/ccfk-assets/latest/ChevronDownSmallIcon';
import ChevronUpSmallIcon from '@nokia-csf-uxr/ccfk-assets/latest/ChevronUpSmallIcon';
import { setSelectMerchant, setSelectMerchantAccount } from "Store/contentState/merchantSlice";
import { setSelectedNetworkDialogData } from "Store/contentState/networkMasterSlice"
import CommonOrdersTab from "Pages/OrdersTab/CommonOrdersTab";
import CommonProductsTabs from "Pages/ProductsTab/CommonProductsTabs";
import ShareIcon from '../Assets/Icons/ShareIcon.svg';
import CommonContractsTabs from "Pages/Contracts/Components/CommonContractsTab";


export const Body = (prop) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const themeSelector = useSelector((state: RootState) => state.theme);
  const authSelector = useSelector((state: RootState) => state.authSlice);
  const commonSliceSelector = useSelector((state: RootState) => state.common);
  const applicationMetadata = useSelector((state: RootState) => state.userManagement.metaData);
  const merchantList = useSelector((state: RootState) => state.merchant.merchantList)
  const persona = useSelector((state: RootState) => state.marketplace.persona)
  const preCiqInformationSelector = useSelector((state: RootState) => state.preCiqNetwork);

  // SideDrawerButton state removed; nav is always expanded
  // Persist opened group indices in Redux so they survive route changes
  const openedGroupIndices: number[] = useSelector((state: RootState) => {
    const val = (state as any).common?.openedGroupIndices;
    return Array.isArray(val) ? val : [];
  });
  const {selectedTab, selectedTabName} = useSelector((state: RootState) => state.common.commonOrderTabDetails);
  // const showButtonBadge = (!!(subMenuOneBadge + subMenuTowBadge) || activeAlarmsBadge) && !isSideDrawerVisible;
  const showButtonBadge = false;
  const marketplaceSelector = useSelector(
    (state: RootState) => state.marketplace
  );
  const userManagementSelector = useSelector(
    (state: RootState) => state.userManagement
  );

  const subscriptionSlice = useSelector(
    (state: RootState) => state.subscription
  );

  const merchantSelector = useSelector(
    (state: RootState) => state.merchant
  );


  const networkMasterSelector = useSelector(
    (state: RootState) => state.networkMaster
  );
  const buttonConfigForAdmin = {
    "User Management": {
      label: "Add user/API user",
      onClick: () => dispatch(setProp({ slice: "userManagement", key: "showUserModal", value: true })),
    },
    "Roles": {
      label: "Add role",
      onClick: () => dispatch(setProp({ slice: "userManagement", key: "showAddRoleDialog", value: true })),
    },
    // Add more configurations as needed for other pages
  };

  const buttonConfigForRadioNetworkCIQ = {
    "RadioNetworkCIQ": {
      label: "Capture data",
      onClick: () => dispatch(setProp({ slice: "radioNetworkCIQ", key: "captureNetworkPlanModal", value: true })),
    },
  };

  const buttonAddNetworks = {
    "AddNetwork": {
      label: "Add network",
      onClick: () => dispatch(setSelectedNetworkDialogData({ showNetworkMasterDialog: true, selectedNetworkData: {}, dialogMode: "add" })),
    },
  };

  const buttonShareCIQ =()=>{
    dispatch(setProp({ slice: "preCiqNetwork", key: "shareDialogStatus", value: true }))
  }





  const SideDrawerProps = {
    onKeyDown: (event) => {
      // Side drawer is persistent; no hide action on ESC
    },
    visible: true,
    className: "dot-side-drawer",
    //variant: "persistent", // Default is "temporary"
    //variant: "temporary",
    variant: "persistent",
    style: {
      position: 'absolute',
      boxShadow: 'none'
    },
    //elevationProps: {elevationIndex: 12},
  };

  const getCurrentPageForAdmin = (items) => {
    return items.length > 0 ? items[0].title : "Unknown"; // Use the first item's title as the current page
  };

  // Check if the current page is an Admin page
  const isAdminPage = prop.crumbs[0] === "Admin";

  // Get the current admin subpage only if it's an Admin page
  const currentAdminSubpage = isAdminPage ? getCurrentPageForAdmin(prop.items) : null;

  // Retrieve the button configuration based on the current subpage
  const buttonConfig = isAdminPage && currentAdminSubpage ? buttonConfigForAdmin[currentAdminSubpage] : null;

  // const formatDate = (date) => {
  //   const year = date.getFullYear(); // Get the year (e.g., 2024)
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Month (1-12), zero-padded
  //   const day = String(date.getDate()).padStart(2, '0'); // Day (1-31), zero-padded

  //   return `${year}-${month}-${day}`;
  // };

  const getWeekMonthYearDataFormat = (analyticsType) => {
    const today = new Date()
    let fromDate = ''
    let toDate = ""
    let lastToDate = ""
    let lastFromDate = ""
    const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    const LastYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    if (analyticsType === "weekly") {
      toDate = formatDate(new Date(today), 'dd-MMM-yyyy')
      fromDate = formatDate(new Date(lastWeek), 'dd-MMM-yyyy')
      lastToDate = fromDate
      let lastFromDateDate = new Date(lastWeek.getFullYear(), lastWeek.getMonth(), lastWeek.getDate() - 7);
      lastFromDate = formatDate(new Date(lastFromDateDate), 'dd-MMM-yyyy')
    }
    else if (analyticsType === "month") {
      let date = today.setMonth(today.getMonth() - 1)
      let month = new Date(date)
      let todaydate = new Date()
      toDate = formatDate(new Date(todaydate), 'dd-MMM-yyyy')
      fromDate = formatDate(new Date(month), 'dd-MMM-yyyy')
    }
    else if (analyticsType === "year") {
      toDate = formatDate(new Date(today), 'dd-MMM-yyyy')
      fromDate = formatDate(new Date(LastYear), 'dd-MMM-yyyy')
    }
    let dataFormate = fromDate + ' - ' + toDate
    return dataFormate
  }

  const dashboardList = [{ "id": "weekly", "value": "Last Week", "name": "Last Week" }, { "id": "month", "value": "Last Month", "name":"Last Month" }, { "id": "year", "value": "Last Year", "name":"Last Year" }]

  const handlePartnerSelection = (selected) => {
    const selectItem = dashboardList.filter((item) => item.id === selected)
    dispatch(setDashboard({ field: 'analytics', value: selectItem.length != 0 ? selectItem[0] : dashboardList[0] }));
  }

  const handleMerchantSelection = (selected) => {
    const selectMerchantItem = merchantList.filter((item) => item.id === selected)
    dispatch(setSelectMerchant(selectMerchantItem.length != 0 ? selectMerchantItem[0]?.id : merchantList[0]?.id));
  }

  const handleMerchantAccountSelection = (selected) => {
    const selectMerchantItem = merchantList.filter((item) => item.id === selected)
    dispatch(setSelectMerchantAccount(selectMerchantItem.length != 0 ? selectMerchantItem[0]?.id : merchantList[0]?.id));
  }

  const calculateRanges = () => {
    const today = new Date();

    // Weekly range
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday (start of the week)
    const endOfWeek = new Date(today);
    endOfWeek.setDate(today.getDate() + (6 - today.getDay())); // Saturday (end of the week)

    // Monthly range
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // 1st day of the month
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the month

    // Yearly range
    const startOfYear = new Date(today.getFullYear(), 0, 1); // 1st January
    const endOfYear = new Date(today.getFullYear(), 11, 31); // 31st December

    return {
      startOfWeek,
      endOfWeek,
      startOfMonth,
      endOfMonth,
      startOfYear,
      endOfYear,
    };
  };

  const url = new URL(window.location.href); // current page URL
  const hasAccessToken = url.searchParams.has("token")
  const contentWrapperStyle = {
    marginLeft: '15px',
    marginRight: '10px',
  };
  const contentNoWrapperStyle = {
    marginLeft: '10px',
    marginRight: '10px',
  };

    const isContractAdd = !!matchPath("/contract/add", location.pathname);
    const isContractEdit = !!matchPath("/contract/edit/:contractId", location.pathname);
    const isContractApproval = !!matchPath("/contract/approval/:contractId", location.pathname);
    const isHubContract = !!matchPath("/contract/hub/:contractId", location.pathname);
    const isAddAgreementTemplate = !!matchPath("/contract/agreement-template/add", location.pathname);
    const isEditAgreementTemplate = !!matchPath("/contract/agreement-template/edit/:templateId", location.pathname);
    const isViewAgreementTemplate = !!matchPath("/contract/agreement-template/view/:templateId", location.pathname);
    const isReviewAgreementTemplate = !!matchPath("/contract/agreement-template/review/:templateId", location.pathname);
    const hideContractTabs = isContractAdd || isContractEdit || isContractApproval || isHubContract || isAddAgreementTemplate || isEditAgreementTemplate || isViewAgreementTemplate || isReviewAgreementTemplate;
    const contractAddCrumbs = [
      { title: "Contracts", path: "/contract" },
      { title: "Create agreement approval", path: "" },
    ];

  const groupedNavigationItems = React.useMemo(() => {
    const DEBUG_USE_HARDCODED = false; // use live metadata from store
    const HARDCODED_META = {
      applicationList: [
        {
          role: "iam_admin",
          groups: [
            {
              id: "1",
              name: "my_workspace",
              applications: [
                "Stock inventory",
                "Subscription",
                "Business Platform Chatbot (β)",
                "Agreement template",
                "Esign",
              ],
            },
            {
              id: "2",
              name: "buy",
              applications: [
                "Marketplace",
                "Dashboard",
                "CIQ",
                "Tasks",
                "Installed base",
              ],
            },
            {
              id: "3",
              name: "installed_base",
              applications: [
                "Users",
                "Frame agreement",
                "User onboarding",
              ],
            },
            {
              id: "4",
              name: "product",
              applications: [
                "Nokia products",
                "Networks",
                "Merchant orders",
              ],
            },
            {
              id: "5",
              name: "deliver",
              applications: [
                "Offer",
                "Profitability",
                "Marketplace orders",
                "Onboarding registration",
              ],
            },
            {
              id: "6",
              name: "account",
              applications: [
                "Quotations",
                "Merchant products",
                "Account",
                "Roles",
                "Assets",
              ],
            },
          ],
        },
      ],
      applicationListNameMapping: {},
    };

    const effectiveMetadata = DEBUG_USE_HARDCODED ? HARDCODED_META : applicationMetadata;
    const applicationListEntry = effectiveMetadata?.applicationList?.[0] || effectiveMetadata?.applicationList || {};
    const applicationGroups = Array.isArray(applicationListEntry?.groups) ? applicationListEntry.groups : [];
    const applicationNameMapping = effectiveMetadata?.applicationListNameMapping || {};

    // If backend returns a flat list (no groups), create a default group so
    // the side nav can still render grouped UI.
    if (!Array.isArray(applicationGroups) || applicationGroups.length === 0) {
      // Try to derive a flat applications array from the response
      const flatApps: string[] = Array.isArray(applicationListEntry?.applications)
        ? applicationListEntry.applications
        : (Array.isArray(effectiveMetadata?.applicationList)
          ? effectiveMetadata.applicationList.flatMap((entry: any) => entry.applications || [])
          : []);

      if (!Array.isArray(flatApps) || flatApps.length === 0) return [];

      const slugify = (value: string) =>
        String(value || "")
          .trim()
          .toLowerCase()
          .replace(/\s+/g, "_")
          .replace(/[^a-z0-9_]/g, "_")
          .replace(/__+/g, "_")
          .replace(/^_+|_+$/g, "");

      const applicationIdByName = Object.entries(applicationNameMapping).reduce((acc, [id, name]) => {
        acc[slugify(String(name))] = id;
        return acc;
      }, {} as Record<string, string>);

      const normalizeApplicationId = (application: string) => {
        const key = slugify(String(application));
        return applicationIdByName[key] || key;
      };

      const addCommonNavigationItemsFlat = (applications: string[]) => {
        const normalizedApplications = applications.map(normalizeApplicationId);
        let nextApplications = [...normalizedApplications];

        const insertAfterMatch = (arr: string[], matchPred: (a: string) => boolean, item: string) => {
          if (arr.includes(item)) return;
          const idx = arr.findIndex(matchPred);
          if (idx !== -1) arr.splice(idx + 1, 0, item);
          else arr.push(item);
        };

        if (normalizedApplications.some((app) => ['orders', 'merchant_orders', 'marketplace_orders'].includes(app))) {
          insertAfterMatch(nextApplications, (a) => ['orders', 'merchant_orders', 'marketplace_orders'].includes(a), 'common_orders');
        }

        if (normalizedApplications.some((app) => app === 'products' || app === 'nokia_products')) {
          insertAfterMatch(nextApplications, (a) => a === 'products' || a === 'nokia_products', 'common_products');
        }

        if (normalizedApplications.some((app) => app === 'frame_agreement' || app === 'agreement_template' || app === 'esign')) {
          insertAfterMatch(nextApplications, (a) => a === 'frame_agreement' || a === 'agreement_template' || a === 'esign', 'contract');
        }

        if (normalizedApplications.some((app) => app === 'user_onboarding' || app === 'onboarding_registration')) {
          insertAfterMatch(nextApplications, (a) => a === 'user_onboarding' || a === 'onboarding_registration', 'onboarding');
        }

        // Ensure marketplace appears first and quotations appears second
        if (nextApplications.includes('marketplace')) {
          nextApplications = nextApplications.filter((a) => a !== 'marketplace');
          nextApplications.unshift('marketplace');
          if (!nextApplications.includes('quotations')) {
            nextApplications.splice(1, 0, 'quotations');
          } else {
            nextApplications = nextApplications.filter((a) => a !== 'quotations');
            nextApplications.splice(1, 0, 'quotations');
          }
        }

        return Array.from(new Set(nextApplications));
      };

      const apps = addCommonNavigationItemsFlat(flatApps).filter((a, i, arr) => arr.indexOf(a) === i);
      return [
        {
          id: 'default',
          name: 'Main',
          applications: apps,
        },
      ];
    }

    const slugify = (value: string) =>
      String(value || "")
        .trim()
        .toLowerCase()
        .replace(/\s+/g, "_")
        .replace(/[^a-z0-9_]/g, "_")
        .replace(/__+/g, "_")
        .replace(/^_+|_+$/g, "");

    const applicationIdByName = Object.entries(applicationNameMapping).reduce((acc, [id, name]) => {
      acc[slugify(String(name))] = id;
      return acc;
    }, {} as Record<string, string>);

    const normalizeApplicationId = (application: string) => {
      const key = slugify(String(application));
      return applicationIdByName[key] || key;
    };
    const addCommonNavigationItems = (applications: string[]) => {
      const normalizedApplications = applications.map(normalizeApplicationId);
      let nextApplications = [...normalizedApplications];

      const insertAfterMatch = (arr: string[], matchPred: (a: string) => boolean, item: string) => {
        if (arr.includes(item)) return;
        const idx = arr.findIndex(matchPred);
        if (idx !== -1) arr.splice(idx + 1, 0, item);
        else arr.push(item);
      };

      if (normalizedApplications.some((app) => ['orders', 'merchant_orders', 'marketplace_orders'].includes(app))) {
        insertAfterMatch(nextApplications, (a) => ['orders', 'merchant_orders', 'marketplace_orders'].includes(a), 'common_orders');
      }

      if (normalizedApplications.some((app) => app === 'products' || app === 'nokia_products')) {
        insertAfterMatch(nextApplications, (a) => a === 'products' || a === 'nokia_products', 'common_products');
      }

      if (normalizedApplications.some((app) => app === 'frame_agreement' || app === 'agreement_template' || app === 'esign')) {
        insertAfterMatch(nextApplications, (a) => a === 'frame_agreement' || a === 'agreement_template' || a === 'esign', 'contract');
      }

      if (normalizedApplications.some((app) => app === 'user_onboarding' || app === 'onboarding_registration')) {
        insertAfterMatch(nextApplications, (a) => a === 'user_onboarding' || a === 'onboarding_registration', 'onboarding');
      }

      // Ensure marketplace appears as the first tab when present and
      // ensure quotations appears as the second tab under marketplace.
      if (nextApplications.includes('marketplace')) {
        nextApplications = nextApplications.filter((a) => a !== 'marketplace');
        nextApplications.unshift('marketplace');

        if (!nextApplications.includes('quotations')) {
          nextApplications.splice(1, 0, 'quotations');
        } else {
          nextApplications = nextApplications.filter((a) => a !== 'quotations');
          nextApplications.splice(1, 0, 'quotations');
        }
      }

      return Array.from(new Set(nextApplications));
    };

    // Build initial groups preserving the order returned by the backend
    // Note: we no longer deduplicate applications across groups so that
    // each group's application order exactly matches the server response.
    const initialGroups = applicationGroups
      .map((group: any) => {
        const applications = addCommonNavigationItems(group?.applications || []);

        return {
          id: group?.id || group?.name,
          name: group?.name || '',
          applications,
        };
      })
      .filter((group) => group.applications.length > 0);

    // Ensure there is a marketplace group containing both `marketplace` and
    // `quotations`. If the computed groups placed `quotations` elsewhere,
    // move it into the marketplace group. If no marketplace group exists
    // but a quotations group does, create a marketplace group at the front.
    try {
      let marketplaceGroupIndex = initialGroups.findIndex((g) => (g.applications || []).includes('marketplace'));
      const quotationsGroupIndex = initialGroups.findIndex((g) => (g.applications || []).includes('quotations'));

      if (marketplaceGroupIndex === -1 && quotationsGroupIndex !== -1) {
        // No existing marketplace group but quotations exists: create a new
        // marketplace group at the front and remove quotations from its source.
        const sourceApps = initialGroups[quotationsGroupIndex].applications.filter(a => a !== 'quotations');
        initialGroups[quotationsGroupIndex].applications = sourceApps;
        initialGroups.unshift({ id: 'marketplace_group', name: 'Marketplace', applications: ['marketplace', 'quotations'] });
        marketplaceGroupIndex = 0;
      } else if (marketplaceGroupIndex !== -1 && quotationsGroupIndex !== -1 && marketplaceGroupIndex !== quotationsGroupIndex) {
        // Move quotations into existing marketplace group
        initialGroups[quotationsGroupIndex].applications = initialGroups[quotationsGroupIndex].applications.filter(a => a !== 'quotations');
        const mqApps = initialGroups[marketplaceGroupIndex].applications || [];
        if (!mqApps.includes('quotations')) {
          const insertAt = Math.max(0, mqApps.indexOf('marketplace')) + 1;
          mqApps.splice(insertAt, 0, 'quotations');
          initialGroups[marketplaceGroupIndex].applications = mqApps;
        }
      }

      // cleanup: remove any empty groups that may have resulted
      const cleaned = initialGroups.filter((g) => (g.applications || []).length > 0);
      // Development debug: log raw backend groups and computed groups to help
      // diagnose ordering issues such as CIQ appearing first unexpectedly.
      // Always emit logs to help debug ordering issues (visible in browser console)
      // eslint-disable-next-line no-console
      console.log('SideNav: raw applicationGroups:', applicationGroups);
      // eslint-disable-next-line no-console
      console.log('SideNav: computed initialGroups:', cleaned);
      return cleaned;
    } catch (e) {
      // ignore and fall back to initialGroups
    }

    return initialGroups;
  }, [applicationMetadata]);

  // Ensure the group containing the current route is opened on navigation
  useEffect(() => {
    try {
      const currentApp = (location.pathname.split('/')[1] || '').toLowerCase();
      // Robust matching: try exact match, then substring matches to handle variations
      const matchIndex = groupedNavigationItems.findIndex((g) => {
        const apps = (g.applications || []).map((a) => String(a || '').toLowerCase());
        return apps.some((a) => a === currentApp || a.includes(currentApp) || currentApp.includes(a));
      });
      if (matchIndex !== -1 && !openedGroupIndices.includes(matchIndex)) {
        dispatch(setProp({ slice: 'common', key: 'openedGroupIndices', value: [...openedGroupIndices, matchIndex] }));
      }
    } catch (e) {
      // ignore
    }
  }, [location.pathname, groupedNavigationItems, dispatch]);

  React.useEffect(() => {
    // Log computed groups for demo purposes when using hardcoded metadata
    // eslint-disable-next-line no-console
    console.log("groupedNavigationItems (demo):", groupedNavigationItems);
  }, [groupedNavigationItems]);

  const renderSideDrawerNavigation = () => {
    if (groupedNavigationItems.length > 0) {
      // Determine if there is a marketplace group so we can remove
      // `quotations` from other groups and always render it under marketplace.
      const marketplaceGroupIndex = groupedNavigationItems.findIndex(g => (g.applications || []).includes('marketplace'));

      return groupedNavigationItems.map((group, groupIndex) => (
        <React.Fragment key={group.id || group.name}>
          <SideDrawerItem
            className={`side-drawer-group-header ${openedGroupIndices.includes(groupIndex) ? 'open' : ''}`}
            label={applicationMetadata?.applicationListNameMapping?.[group?.id] || String(group.name || '').replace(/_/g, ' ')}
            expandableHeaderIndicator={openedGroupIndices.includes(groupIndex) ? <ChevronUpSmallIcon aria-label="close group"/> : <ChevronDownSmallIcon aria-label="open group"/>}
            onClick={() => {
              const isOpen = openedGroupIndices.includes(groupIndex);
              const next = isOpen ? openedGroupIndices.filter(i => i !== groupIndex) : [...openedGroupIndices, groupIndex];
              dispatch(setProp({ slice: 'common', key: 'openedGroupIndices', value: next }));
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const isOpen = openedGroupIndices.includes(groupIndex);
                const next = isOpen ? openedGroupIndices.filter(i => i !== groupIndex) : [...openedGroupIndices, groupIndex];
                dispatch(setProp({ slice: 'common', key: 'openedGroupIndices', value: next }));
              }
            }}
            badge={undefined}
          />
          {openedGroupIndices.includes(groupIndex) && (
            <div className="side-drawer-group-container" role="group" aria-label={String(group.name || '')}>
              {(() => {
                const apps = Array.isArray(group.applications) ? [...group.applications] : [];

                // If a marketplace group exists, remove `quotations` from all other groups
                if (marketplaceGroupIndex !== -1 && groupIndex !== marketplaceGroupIndex) {
                  // Do not reorder or remove other applications here; just ensure
                  // we do not duplicate `quotations` across groups — filter only
                  // when rendering the final links so order stays intact.
                  const filtered = apps.filter(a => a !== 'quotations');
                  return filtered.map((navItem, idx) => (
                    <LoadNavLinks
                      key={navItem}
                      navItem={navItem}
                      groupItem
                      orderIndex={idx}
                      firstGroupItem={idx === 0}
                      lastGroupItem={idx === filtered.length - 1}
                      groupHeaderHasIcon={commonSliceSelector.sideBarOpen}
                    />
                  ));
                }

                // For the marketplace group, ensure quotations is immediately after marketplace
                if (apps.includes('marketplace') && !apps.includes('quotations')) {
                  const insertAt = Math.max(0, apps.indexOf('marketplace')) + 1;
                  apps.splice(insertAt, 0, 'quotations');
                } else if (apps.includes('marketplace') && apps.includes('quotations')) {
                  // move quotations to second position
                  const others = apps.filter(a => a !== 'quotations');
                  const insertAt = Math.max(0, others.indexOf('marketplace')) + 1;
                  others.splice(insertAt, 0, 'quotations');
                  return others.map((navItem, idx) => (
                    <LoadNavLinks
                      key={navItem}
                      navItem={navItem}
                      groupItem
                      orderIndex={idx}
                      firstGroupItem={idx === 0}
                      lastGroupItem={idx === others.length - 1}
                      groupHeaderHasIcon={commonSliceSelector.sideBarOpen}
                    />
                  ));
                }

                return apps.map((navItem, idx) => (
                  <LoadNavLinks
                    key={navItem}
                    navItem={navItem}
                    groupItem
                    orderIndex={idx}
                    firstGroupItem={idx === 0}
                    lastGroupItem={idx === apps.length - 1}
                    groupHeaderHasIcon={commonSliceSelector.sideBarOpen}
                  />
                ));
              })()}
            </div>
          )}
        </React.Fragment>
      ));
    }

    return marketplaceSelector.userAccessInfo
      ?.map((navItem: string) => <LoadNavLinks key={navItem} navItem={navItem} />);
  };

  // Measure side drawer width and adjust content margin so main content starts after the drawer
  const sideDrawerRef = useRef<HTMLDivElement | null>(null);
  const [sideDrawerWidth, setSideDrawerWidth] = useState<number>(240);

  useEffect(() => {
    const measure = () => {
      if (sideDrawerRef.current) {
        const w = sideDrawerRef.current.offsetWidth || 240;
        setSideDrawerWidth(w);
        // expose measured drawer width as a CSS variable so we avoid
        // adding inline `margin-left` to the AppContentWrapper element.
        try {
          document.documentElement.style.setProperty('--dot-side-drawer-width', `${w}px`);
        } catch (e) {
          // ignore (server-side render or restricted env)
        }
      }
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  // update content wrapper style based on measured drawer width
  const computedContentWrapperStyle = {
    // Keep visual padding/margins but avoid inline margin-left; the
    // actual left offset is provided via the CSS variable
    paddingLeft: 0,
    marginRight: '10px',
  };

  return (
    <>
      <AppBody id="app-body">
        {!hasAccessToken && <SideDrawer {...SideDrawerProps}>
          <div ref={sideDrawerRef} style={{ height: "100%", boxShadow: "none" }}>
            <SideDrawerList>
                  {renderSideDrawerNavigation()}
                  {/* Debug UI: when ?debugSideNav=true is present, show computed groups and apps */}
                  {(() => {
                    try {
                      const showDebug = new URL(window.location.href).searchParams.get('debugSideNav') === 'true';
                      if (!showDebug) return null;
                      return (
                        <div style={{ padding: 12, borderTop: '1px dashed #ddd', marginTop: 8 }}>
                          <div style={{ fontWeight: 700, marginBottom: 6 }}>SideNav Debug (computed groups)</div>
                          <pre style={{ maxHeight: 240, overflow: 'auto', fontSize: 12 }}>{JSON.stringify(groupedNavigationItems, null, 2)}</pre>
                        </div>
                      );
                    } catch (e) {
                      return null;
                    }
                  })()}
            </SideDrawerList>
          </div>
        </SideDrawer>}
        <AppContentWrapper style={!hasAccessToken ? computedContentWrapperStyle : contentNoWrapperStyle} >
          {prop.crumbs[0] === "Marketplace" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>

                  <AppToolbarTitleContainer>
                    <AppToolbarTitle style={{ padding: "0px !important" }}>
                      {/* Render Marketplace tabs where breadcrumbs appear */}
                      <div>
                        {/* Render only Marketplace tabs in toolbar title area (no breadcrumb) */}
                        {/* eslint-disable-next-line @typescript-eslint/no-var-requires */}
                        {prop.crumbs[0] === 'Marketplace' && React.createElement(require('Pages/marketplace/common/MarketplaceTabs').default)}
                      </div>
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {/* <MarketplaceTitleBar /> */}
                    {/* <CommonFilter /> */}
                    <AccountInfo />
                    <FilterButtons />
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}
          {prop?.crumbs[0]?.startsWith("Subscription") && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      {subscriptionSlice?.AppToolbarTitle}
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>{""}</AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Marketplace / Cart" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>{""}</AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Marketplace / Product" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {/* <MarketplaceTitleBar /> */}
                    <AccountInfo />
                    <FilterButtons />
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Quotations" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {/* <QuotationsFilter /> */}
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                      <CommonFilter />
                    </div>
                    {/* <FilterButtons /> */}
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {isAdminPage && buttonConfig && (
            <AppHeader>
              <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                <AppToolbarTitleContainer>
                  <AppToolbarTitle>
                    <BreadCrum items={prop.items} separator=" > " />
                  </AppToolbarTitle>
                </AppToolbarTitleContainer>
                <AppToolbarContent>
                  <Button
                    variant="call-to-action"
                    onClick={buttonConfig.onClick}
                  >
                    <ButtonIcon><AddIcon/></ButtonIcon>
                    <ButtonText>{buttonConfig.label}</ButtonText>
                  </Button>
                </AppToolbarContent>
              </AppToolbar>
            </AppHeader>
          )}

          {prop.crumbs[0] === "Orders" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                      <CommonFilter />
                    </div>
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Merchant Dashboard" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {persona === "nokia" && merchantList.length != 0 && <div style={{ paddingRight: '20px', marginTop: '5px' }}>
                      <SelectBox
                        labelText={""}
                        placeholder="Select merchant"
                        maxWidth={true}
                        caseInsentiveMatching={true}
                        selectedItem={merchantSelector?.selectedMerchant}
                        data={merchantList}
                        onUpdateSelection={handleMerchantSelection}
                        isLoading={marketplaceSelector.isPartnerLoading}
                        calendar={false}
                      />
                    </div>}
                    <div className="testdata" style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
                      <SelectBox
                        labelText={""}
                        placeholder="Select Analytics"
                        maxWidth={true}
                        caseInsentiveMatching={true}
                        selectedItem={merchantSelector?.merchantDashboard?.analytics?.id}
                        data={dashboardList}
                        onUpdateSelection={handlePartnerSelection}
                        isLoading={marketplaceSelector.isPartnerLoading}
                        calendar={true}
                      />
                      <div style={{ height: '2.5rem', marginTop: '10px', paddingLeft: '5px' }}>
                        <Tooltip
                          closeOnReferenceHidden={false}
                          placement="bottom-end"

                          modifiers={[{ name: 'offset' }]}
                          trigger="hover"
                          tooltip={merchantSelector?.merchantDashboard?.analytics?.value + "  [" + getWeekMonthYearDataFormat(merchantSelector?.merchantDashboard?.analytics?.id) + "]"}
                        >
                          <HelpCircleIcon size={25} />
                        </Tooltip>
                      </div>
                    </div>
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Merchant Products" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Merchant Orders" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" > " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "common_orders" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <CommonOrdersTab />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {selectedTabName === "Marketplace orders" ? <CommonFilter/> : persona === "nokia" && merchantList.length != 0 && <div style={{ paddingRight: '20px', marginTop: '5px' }}>
                      <SelectBox
                        labelText={""}
                        placeholder="Select merchant"
                        maxWidth={true}
                        caseInsentiveMatching={true}
                        selectedItem={merchantSelector?.selectedMerchantAccount}
                        data={merchantList}
                        onUpdateSelection={handleMerchantAccountSelection}
                        isLoading={marketplaceSelector.isPartnerLoading}
                        calendar={false}
                      />
                    </div>}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "common_products" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      Products
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    <CommonProductsTabs />
    
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "common_contracts" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      {prop.crumbs.length > 1 ? (
                        <BreadCrum items={[
                          { title: "Contracts", path: "/contract", ...(prop.onContractsBreadcrumbClick ? { onClick: prop.onContractsBreadcrumbClick } : {}) },
                          { title: prop.crumbs[1], path: "" },
                        ]} separator=" > " />
                      ) : (
                        "Contracts"
                      )}
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {!hideContractTabs && <CommonContractsTabs />}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Radio_network" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    <Button
                      variant="call-to-action"
                      onClick={buttonConfigForRadioNetworkCIQ["RadioNetworkCIQ"].onClick}
                    >
                      <ButtonIcon><img src={capturePencilIcon} /></ButtonIcon>
                      <ButtonText>{buttonConfigForRadioNetworkCIQ["RadioNetworkCIQ"].label}</ButtonText>
                    </Button>
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}
          {prop.crumbs[0] === "Radio_network / Plan" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle style={{ paddingLeft: 0 }}>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    <Button
                      variant="call-to-action"
                      onClick={buttonConfigForRadioNetworkCIQ["RadioNetworkCIQ"].onClick}
                    >
                      <ButtonIcon><img src={capturePencilIcon} /></ButtonIcon>
                      <ButtonText>{buttonConfigForRadioNetworkCIQ["RadioNetworkCIQ"].label}</ButtonText>
                    </Button>
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}
          {prop.crumbs[0] === "Networks" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {["data_governor", "delivery"].includes(authSelector.userDatamart_role?.[0]) ? <Button
                      variant="call-to-action"
                      onClick={buttonAddNetworks["AddNetwork"].onClick}
                    >
                      <ButtonIcon><AddIcon /></ButtonIcon>
                      <ButtonText>{buttonAddNetworks["AddNetwork"].label}</ButtonText>
                    </Button> : ""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}
 

             {prop.crumbs[0] === "networks_details" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }}  className="my-parent-wrapper" style={{ borderRadius: '10px' }}>
                   <style>
                    {`
                      .my-parent-wrapper [class*="styles__Titles"] {
                        max-width: 100% !important;
                      }
                    `}
                  </style>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "selected_network" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Pre_ciq_network" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Pre_ciq_network Plan" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                      {!preCiqInformationSelector.preCiqNetworkPlanLoading && !hasAccessToken &&  preCiqInformationSelector.shareAccessStatus && <Button
                      variant="call-to-action"
                      onClick={()=>buttonShareCIQ()}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <img src={ShareIcon} alt="share" style={{
                          width: "20px",
                          height: "20px",
                          objectFit: "contain",
                          display: "block",
                        }} />
                        <ButtonText style={{ marginBottom: '5px' }}>Share the CIQ</ButtonText>
                      </div>
                    </Button>}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "stock_inventory" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                     {persona === "nokia" && merchantList.length != 0 && <div style={{ paddingRight: '20px', marginTop: '5px' }}>
                      <SelectBox
                        labelText={""}
                        placeholder="Select merchant"
                        maxWidth={true}
                        caseInsentiveMatching={true}
                        selectedItem={merchantSelector?.selectedMerchantAccount}
                        data={merchantList}
                        onUpdateSelection={handleMerchantAccountSelection}
                        isLoading={marketplaceSelector.isPartnerLoading}
                        calendar={false}
                      />
                    </div>}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Case" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }}  className="my-parent-wrapper">
                   <style>
                    {`
                      .my-parent-wrapper [class*="styles__Titles"] {
                        max-width: 100% !important;
                      }
                    `}
                  </style>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

           {prop.crumbs[0] === "Tasks" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {prop.crumbs[0] === "Assets" && (
            <>
              <AppHeader>
                <AppToolbar elevationProps={{ elevationIndex: 0 }} style={{ borderRadius: '10px' }}>
                  <AppToolbarTitleContainer>
                    <AppToolbarTitle>
                      <BreadCrum items={prop.items} separator=" - " />
                    </AppToolbarTitle>
                  </AppToolbarTitleContainer>
                  <AppToolbarContent>
                    {""}
                  </AppToolbarContent>
                </AppToolbar>
              </AppHeader>
            </>
          )}

          {/* Generic Header for all other pages - Can be passed customized app header */}
          {
            prop?.AppHeader && (prop.AppHeader as React.ReactElement)
          }

          <AppContent
            id="dot-app-content"
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              paddingTop: "10px",
              width: "100%",
              overflow: "hidden",
              // marginRight: '10px'
            }}
          >
            {prop.bodyContent}

            <Snackbar
              onClick={() =>
                dispatch(
                  showPopup({ msg: "", show: !authSelector.system.popup.show })
                )
              }
              autoCloseDuration={2000}
              open={authSelector.system.popup.show}
              autoClose={true}
            >
              <SnackbarContent>{authSelector.system.popup.msg}</SnackbarContent>
            </Snackbar>
            <DialogModal
              type="popup"
              isOpen={authSelector.system.modal.show}
              popInfo={{
                msg: authSelector.system.modal.msg,
                title: authSelector.system.modal.title,
                variant: authSelector.system.modal.variant,
                panel: {
                  msg: authSelector.system.modal.panel.msg,
                  title: authSelector.system.modal.panel.title,
                  show: themeSelector.data.panel.isOpen.global,
                  onExpand: () => {
                    dispatch(
                      setTheme({
                        element: "panel",
                        comp: "global",
                        prop: "isOpen",
                        value: !themeSelector.data.panel.isOpen.global,
                      })
                    );
                  },
                },
              }}
              //@ts-ignore
              actionBtns={
                authSelector.system.modal.action.length === 0
                  ? [
                    {
                      label: "Close",
                      variant: "call-to-action",
                      onAction: () => {
                        dispatch(
                          showModal({
                            msg: "",
                            panel: { title: "", msg: "" },
                            show: !authSelector.system.modal.show,
                          })
                        );
                      },
                    },
                  ]
                  : authSelector.system.modal.action.map((payload) => ({
                    ...payload,
                    onAction: deserializeFunction(payload.onAction),
                  }))
              }
            />



          </AppContent>
          {/* {!location.pathname.includes("subscription") && !location.pathname.includes("account") && <Footer />} */}
          <Footer />
        </AppContentWrapper>

      </AppBody>

    </>
  );
};
